import { render, staticRenderFns } from "./MultipleCustomCardsChips.vue?vue&type=template&id=18ff231a&scoped=true"
import script from "./MultipleCustomCardsChips.vue?vue&type=script&lang=js"
export * from "./MultipleCustomCardsChips.vue?vue&type=script&lang=js"
import style0 from "./MultipleCustomCardsChips.vue?vue&type=style&index=0&id=18ff231a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ff231a",
  null
  
)

export default component.exports